import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import LoginView from '@/views/LoginView'
import HomeView from '@/views/HomeView'
import AreaView from '@/views/AreaView'
import StructureView from '@/views/StructureView'
import PhotosView from '@/views/PhotosView'
import CameraView from '@/views/CameraView'
import SyncView from '@/views/SyncView'
import SyncQueue from '@/views/SyncQueue'
import SyncAreaPhotos from '@/views/SyncAreaPhotos'
import store from '../store'

Vue.use(Router)

function requireAuth (to, from, next) {
  store.dispatch('CURRENT_USER').then(currentUser => {
    if (currentUser) {
      next()
    } else {
      next({ path: '/login' })
    }
  }).catch(() => {
    next({ path: '/login' })
  })
}

function isFirstTime (to, from, next) {
  store.dispatch('CURRENT_USER').then(currentUser => {
    if (currentUser) {
      next({ path: '/home' })
    } else {
      next()
    }
  }).catch(() => {
    next()
  })
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      beforeEnter: isFirstTime
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginView
    },
    {
      path: '/home',
      name: 'Home',
      component: HomeView,
      beforeEnter: requireAuth
    },
    {
      path: '/areas',
      name: 'Areas',
      component: AreaView,
      beforeEnter: requireAuth
    },
    {
      path: '/structures',
      name: 'Structures',
      component: StructureView,
      beforeEnter: requireAuth
    },
    {
      path: '/photos',
      name: 'Photos',
      component: PhotosView,
      beforeEnter: requireAuth
    },
    {
      path: '/camera',
      name: 'Camera',
      component: CameraView,
      beforeEnter: requireAuth
    },
    {
      path: '/sync',
      name: 'Sync',
      component: SyncView,
      beforeEnter: requireAuth
    },
    {
      path: '/queue',
      name: 'Queue',
      component: SyncQueue,
      beforeEnter: requireAuth
    },
    {
      path: '/syncArea',
      name: 'SyncArea',
      component: SyncAreaPhotos,
      beforeEnter: requireAuth
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js